import React from 'react';

import { Navbar, LoginForm } from '..';

export const LoginPage: React.FC = React.memo(() => {
    return (
        <div className='admin-section'>
            <Navbar login />
            <LoginForm />
        </div>
    );
});
